import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getOperationIndustrieStub } from '../../../../config/operations-industrie';

export default function EclairagePage() {
  const parcours = getOperationIndustrieStub('eclairage');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="industrie"
      segment="operations"
      segmentLabel="Utilités & process"
      crossLinks={[
        {
          label: 'CEE IND-UT / IND-BA',
          href: '/industrie/aides/cee-ind',
          iconName: 'sparkles',
          hint: 'Primes énergie sur la fiche BAT-EQ-127',
        },
        {
          label: 'Audit énergétique NF EN 16247',
          href: '/industrie/operations/audit-reglementaire',
          iconName: 'file-search',
          hint: "Inclure l'éclairage au périmètre audit",
        },
        {
          label: 'ISO 50001',
          href: '/industrie/iso-50001',
          iconName: 'shield-check',
          hint: 'Intégrer la consommation éclairage aux IPE',
        },
      ]}
      crossLinksAllLabel="Toutes les aides industrie"
      crossLinksAllHref="/industrie/aides"
    />
  );
}
